export default {
  revenueLines: [],
  revenueLine: undefined,
};
